import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

export default class EventCarousel {
	constructor() {
		this.init();
	}

	init() {
		let eventCarouselElement = document.querySelectorAll( '[data-event-carousel="element"]' );

		eventCarouselElement.forEach( ( element ) => {
			let carousel = new Splide( element, {
                arrows: false,
				mediaQuery: 'min',
				grid: false,
				pagination: false,
				padding: {
					right: '30vw'
				},
				gap: '0',
				breakpoints: {
					992: {
						gap: '30px',
						grid: {
							rows: 2
						},
						padding: false
					},
					1400: {
						gap: '50px',
						grid: {
							rows: 2
						},
						padding: false
					}
			 	}
            } ).mount( { Grid } );
		} );
	}
}
